<ng-container *ngIf="ticketStatusId">
	<ion-button
		class="status-btn"
		[style.color]="fgColor"
		[color]="color"
		[style.backgroundColor]="bgColor"
		[expand]="expand"
		[size]="size"
		[fill]="fill"
		(click)="onClickShowStatusOptions()"
	>
		{{ ticketStatusDesc || "Status" }}
	</ion-button>
	<ion-item [hidden]="true">
		<ion-label>
			Status
		</ion-label>
		<ion-select
			#statusSelectRef
			*ngIf="transitions"
			(ionChange)="onChangeUpdateStatus($event)"
		>
			<ion-select-option
				*ngFor="let status of validDestinations"
				[value]="status"
			>
				{{ status.transitionName }}
			</ion-select-option>
		</ion-select>
	</ion-item>
</ng-container>
